import React from 'react'
import TemplateList from '../common/TemplateList'
import ClinicSmsTemplate from './ClinicSmsTemplate'

function SmsDashboard() {
  return (
    <div className="container container-xxl">
    <div className="row">
        <div className="col-6">
          <TemplateList type="sms"/>
        </div>
        <div className="col-6">
          <ClinicSmsTemplate />
        </div>
    </div>
  </div>
  )
}

export default SmsDashboard